<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\forgotPassManual-1.png" alt="" /></div>
                <div>
                    <p>① パスワードを忘れてしまった場合は、ログイン画面の下部にある「パスワードをお忘れの場合はこちらをクリックしてください」をクリックしてください。</p>
                </div>
                <div><img src="/static\images\ja\newManual\forgotPassManual-2.png" alt="" /></div>
                <div>
                    <p>② アカウントの登録に使用したメールアドレスを「パスワードのリセット」画面に入力します。</p>
                    <p>③ 「送信」ボタンを押下し、リセット用のメールをアドレスを送信します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\forgotPassManual-3.png" alt="" /></div>
                <div>
                    <p>④ メール情報の送信に成功すると、「パスワードリセットメール送信完了」画面が表示されます。</p>
                    <p>&nbsp;メールソフトを開き、「StudyArts」から送信されたメールを確認します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\forgotPassManual-4.png" alt="" /></div>
                <div>
                    <p>⑤ メールの[パスワードリセットURL]リンクにアクセスし、新しいパスワードをリセットします。</p>
                    <p>※ 注：「パスワードの再設定URL」は、メールが送信されてから10分間のみ有効です。</p>
                    <p>&nbsp;10分以上経過した場合はURLが失効しますため、「①」手順からもう一度実施してください。</p>
                </div>
                <div><img src="/static\images\ja\newManual\forgotPassManual-5.png" alt="" /></div>
                <div>
                    <p>⑥ メール内のURLにアクセスすると、「パスワードのリセット」画面が表示されます。</p>
                    <p>&nbsp;新しいパスワードを入力し、「確認」ボタンを押してください。</p>
                    <p>※ 注：パスワードは、大文字、小文字、数字を含めて8～16文字であることを注意してください。</p>
                </div>
                <div><img src="/static\images\ja\newManual\forgotPassManual-6.png" alt="" /></div>
                <div>
                    <p>⑦ 新しいパスワードを正常にリセットすると、次の画面が表示されます。</p>
                    <p>&nbsp;「ホームに戻る」ボタンを押下し、システムのログイン画面に戻り、新しいパスワードにてログインしてください。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/forgotPass_manual.vue